<template>
    <div id="index" class="animate-in">
        <!--顶部搜索筛选-->
        <div class="row">
            <div class="col-md-12">
                <div class="box fz-content-box">
                    <div class="box-body fz-box-body">
                    
                        <form class="form-inline searchForm" id="searchForm" action="#" method="GET">
                            <div class="form-group mr15"><span class="fz-menu-name">{{menuName}}</span></div>

                            <div class="form-group">
                                <input value=""
                                    name="_keywords" id="_keywords" class="form-control input-sm fz-input-radiu" placeholder="输入用户ID">
                            </div>
                            <div class="form-group">
                                <a href="#" class="fz-goto-search" @click="toSearch">
                                    <i class="fa fa-search"></i>
                                </a>
                            </div>

                            <div class="form-group fz-input-time ml30">			
                                <div class="input-group date fz-input-time-width" id="datetimepicker1">
                                    <input type="text" class="timeInput form-control input-sm fz-input-radiu" id="startTime" v-model="startTime" readonly />
                                    <span class="input-group-addon fz-group-addon-width">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                                <span class="fz-color-white">&nbsp;至&nbsp;</span>         
                                <div class="input-group date fz-input-time-width"  id="datetimepicker2">
                                    <input type="text" class="timeInput form-control input-sm fz-input-radiu" id="endTime" v-model="endTime" readonly />
                                    <span class="input-group-addon fz-group-addon-width">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--数据列表页面-->
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="box fz-box">
                        <div class=" table-responsive">
                            <table class="table table-hover fz-table-hover fz-table-bordered datatable" width="100%">
                                <thead>
                                <tr class="fz-gray">
                                    <th>序号</th>
                                    <th>用户ID</th>
                                    <th>地区</th>
                                    <th>订单号</th>
                                    <th>充值金额</th>
                                    <th>余额</th>
                                    <th>充值时间</th>
                                </tr>
                                </thead>
                                <tbody>
                                
                                <tr v-for="(item,index) in currentList" :key="item.key" :class="[index===1?'active':'']">
                                    <td>{{item.sortindex}}</td>
                                    <td>{{item.userid}}</td>
                                    <td>{{item.area}}</td>
                                    <td>{{item.ordersn}}</td>
                                    <td>{{item.money}}</td>
                                    <td>{{item.account}}</td>
                                    <td>{{item.addTime | datefmt("YYYY-MM-DD HH:mm:ss")}}</td>
                                </tr>
                                
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <!-- 数据列表底部 -->
                    <div class="fz-box-footer center-block text-center">
                        <pagination :num="num" :limit="limit" @getNew="getNew"></pagination>
                    </div>
                </div>
            </div>
        </section>

        
    </div>
</template>

<script>
import pagination from "@/components/pagination.vue"
import '@/static/plugins/bootstrap-datetimepicker/js/bootstrap-datetimepicker.js';
import '@/static/plugins/bootstrap-datetimepicker/js/locales/bootstrap-datetimepicker.zh-CN.js';
import '@/static/plugins/bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';


export default {
    name: 'rechargeList',
    data() {
        return {
            menuName: "充值查询",
            loading: false, //是显示加载
            startTime: "",
            endTime: "",
            listData: [
                {
                    id: 1,
                    sortindex: "001",
                    userid: "1233453222",
                    area: "广东深圳",
                    ordersn: "2019201020232929222",
                    money: "￥260.00",
                    account: "￥129.00",
                    addTime: 1585238258,
                },
                 {
                    id: 1,
                    sortindex: "001",
                    userid: "1233453222",
                    area: "广东深圳",
                    ordersn: "2019201020232929222",
                    money: "￥260.00",
                    account: "￥129.00",
                    addTime: 1585238258,
                },
                 {
                    id: 1,
                    sortindex: "001",
                    userid: "1233453222",
                    area: "广东深圳",
                    ordersn: "2019201020232929222",
                    money: "￥260.00",
                    account: "￥129.00",
                    addTime: 1585238258,
                },
            ],
            currentList: [],
            // 分页参数
            num: 0,
            limit: 2,
            pageparm: {
                currentPage: 1,
                pageSize: 2,
                total: 9
            }
        }
    },
    components: {
        pagination
    },
    created() {
        
    }, 
    mounted() {
        this.getNew(0);
        this.num = this.listData.length;
        //必须在组件渲染之后调用
        this._dateDefault();
    },
    methods: {
        _dateDefault() {
            let _this = this;
            $('#datetimepicker1').datetimepicker({
                language:  'zh-CN',
                format: 'yyyy-mm-dd hh:ii',
                weekStart: 1,
                todayBtn:  1,
                autoclose: 1,
                todayHighlight: 1,
                startView: 2,
                minView: 0,
                maxView: 1,
                forceParse: 0,
            }).on("hide", function(ev) {
                var value = $("#startTime").val();
                _this.startTime = value;
            });

            $('#datetimepicker2').datetimepicker({
                language:  'zh-CN',
                format: 'yyyy-mm-dd hh:ii',
                weekStart: 1,
                todayBtn:  1,
                autoclose: 1,
                todayHighlight: 1,
                startView: 2,
                minView: 0,
                maxView: 1,
                forceParse: 0,
            }).on("hide", function(ev) {
                var value = $("#endTime").val();
                _this.endTime = value;
            });
        },
        getNew(value) {
            console.log(value);
            this.currentList = this.listData.slice(value, value + this.limit);
            console.log(this.currentList);
        },
        toSearch() {
            console.log(this.startTime, this.endTime);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
